import React, { useState,useContext, useEffect } from 'react';
import DynamicIcon from '../../components/dynamicicon';
import JisButton from '../../components/controls/jisButton';
import JisCheckbox from '../../components/controls/jisCheckbox';
import { ShareContext } from '../../context/ShareContext'
import * as Constants from '../../constants';
import * as Services from '../../services';
import JisTabButton from '../../components/controls/jisTabButton';
import BackLoader from '../../components/backloader';
import JisDialog from '../../components/dialog';
import JisDialogForm from '../../components/formdialog';

function LocationSettings() {
  const {activePage, token, setIsExpired,setAlert,frequentData} = useContext(ShareContext);
  const [page, setPage] = useState(null);
  const [tab, setTab] =useState('divisions');

  const [divisions, setDivisions] = useState([]);
  const [division, setDivision] = useState({id:0});
  const [states, setStates] = useState([]);
  const [state,setState] = useState({});
  const [lg, setLg] = useState({id:0});
  const [lgs, setLgs] = useState([]);
  const [city, setCity] = useState({id:0});
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isDialog, setIsDialog] = useState(false);
  const [err, setErr] = useState('');

  useEffect(() => {           
    onLoadDivisions();
    onLoadStates();
    onLoadLgs();
    onLoadCities();
  }, []);

  const onDivisionChange = (e) => {
        setDivision({...division, [e.target.name]: e.target.value})   
    }

    const onStateChange = (e) => {
        setState({...state, [e.target.name]: e.target.value})   
    }
    const onLgChange = (e) => {
        setLg({...lg, [e.target.name]: e.target.value})   
    }
    const onCityChange = (e) => {
        setCity({...city, [e.target.name]: e.target.value})   
    }

    const onLoadDivisions= async()=>{
         //for account registration
         try {
           setLoading(true);
             const resp = await fetch(`${Constants.apiUrl}/setup/location-setting/divisions`, { 
               method: 'GET',
               headers: {
                 'Content-Type': 'application/json',
                 'Authorization': `Bearer ${token}`,
               },
             });
             
             const data = await resp.json();
             setLoading(false);
            setDivisions(data.list);
            
           } catch (error) {
             setLoading(false);
             console.error(error);
             
           }
     }
     const onLoadStates= async()=>{
         //for account registration
         try {
           setLoading(true);
             const resp = await fetch(`${Constants.apiUrl}/setup/location-setting/states`, { 
               method: 'GET',
               headers: {
                 'Content-Type': 'application/json',
                 'Authorization': `Bearer ${token}`,
               },
             });
             
             const data = await resp.json();
             setLoading(false);
            setStates(data.list);
            
           } catch (error) {
             setLoading(false);
             console.error(error);
             
           }
     }
     const onLoadLgs= async()=>{
         //for account registration
         try {
           setLoading(true);
             const resp = await fetch(`${Constants.apiUrl}/setup/location-setting/lgs`, { 
               method: 'GET',
               headers: {
                 'Content-Type': 'application/json',
                 'Authorization': `Bearer ${token}`,
               },
             });
             
             const data = await resp.json();
             setLoading(false);
            setLgs(data.list);
            
           } catch (error) {
             setLoading(false);
             console.error(error);
             
           }
     }

     const onLoadCities= async()=>{
         //for account registration
         try {
           setLoading(true);
             const resp = await fetch(`${Constants.apiUrl}/setup/location-setting/cities`, { 
               method: 'GET',
               headers: {
                 'Content-Type': 'application/json',
                 'Authorization': `Bearer ${token}`,
               },
             });
             
             const data = await resp.json();
             setLoading(false);
            setCities(data.list);
            
           } catch (error) {
             setLoading(false);
             console.error(error);
             
           }
     }
 
     const onEdit=(obj,index)=>{
        setErr('');
          setIsDialog(true);
        if(tab=='divisions'){
            
            setDivision(obj)
        } 
       else if(tab=='states'){
          
            setState(obj)
        }
       else if(tab=='lgs'){
           
            setLg(obj)
        }
        else if(tab=='cities'){
           
            setCity(obj)
        }
     }
     const onAdd=()=>{
        setIsDialog(true);
     }

  const onSave=async(e)=>{
        e.preventDefault();
       var path='';
       var obj=null;
       if(tab=='divisions' ){
            path='/setup/location-setting/division';
            obj={...division};
        }
         else if(tab=='states'){
            path='/setup/location-setting/state';
            obj={...state};
        }
         else if(tab=='lgs'){
            path='/setup/location-setting/lg';
            obj={...lg};
        }
        else if(tab=='cities'){
            path='/setup/location-setting/city';
            obj={...city};
        }

    setLoading(true)
                     try {
                       
                       const url=`${Constants.apiUrl}${path}`;
                       const resp = await fetch(url, {
                         method: 'POST',
                         body:JSON.stringify(obj) ,
                         headers: {
                           'Content-Type': 'application/json, text/plain',
                           Authorization: `Bearer ${token}`,
                         },
                       });
                       
                       const data = await resp.json();
                       setLoading(false);
                       if(data.code==0){
                        setAlert({open:true, title:'Setting',subtitle:'Settings saved successfully'})
                            onDefault(data.id);
                       }
                       else if(data.code==-10){
                             setIsExpired(true);
                         }else{
                           setErr(data.status);
                         }
                    //   setFlow({pos:6,code:"congrat"})
                       
                       
                     } catch (error) {
                       setLoading(false);
                       console.error(error);
                       
                      // onMove();
                     }
    }

    const onDefault=(id)=>{
        setErr('');
          setIsDialog(false);
        if(tab=='divisions'){
            onLoadDivisions();
            setDivision({id:0})
        } 
       else if(tab=='states'){
            onLoadStates()
            setState({id:0})
        }
       else if(tab=='lgs'){
            onLoadLgs()
            setLg({id:0})
        }
        else if(tab=='cities'){
            onLoadCities()
            setCity({id:0})
        }
    }

    const onClose=()=>{
        setIsDialog(false);
        setDivision({id:0})
        setState({id:0});
        setLg({id:0});
        setCity({id:0});

    }

  return (
    <div>
     <div  className='tab_body'>
        <div className='tab_section' style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
          <JisTabButton code="divisions" isActive={tab=='divisions'}  title="Divisions" data={page} isRoleBased={false} onClick={()=> setTab('divisions')}/>
          <JisTabButton code="states" isActive={tab=='states'}  title="States" data={page} isRoleBased={false}  onClick={()=> setTab('states')}/>
        <JisTabButton code="lgs" isActive={tab=='lgs'}  title="Local Government" data={page} isRoleBased={false}  onClick={()=> setTab('lgs')}/>
        <JisTabButton code="cities" isActive={tab=='cities'}  title="City" data={page} isRoleBased={false}  onClick={()=> setTab('cities')}/>    

        </div>
     {tab=='divisions' && <div  className='tab_view'>
            <div style={{textAlign:'right'}}> <JisButton variant='plain' onClick={onAdd}>Add Division</JisButton></div>
            <div className='table'>
            <div class="section-cases">
                <span>Divisions</span><span className='total'>{divisions?.length}</span>
            </div>
            <table className="case-table">
                <thead>
                    <tr>
                        <th>SN</th>
                        <th>Title</th>
                        <th>Code</th>
                        <th>Email</th>
                        <th>Phone#</th>
                        <th>Address</th>
                        <th>PayerId</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                   { divisions.map((g, i) => { return (
                    <tr>
                        <td>{i+1}</td>
                        <td>{g.title}</td>
                        <td>{g.code}</td>
                        <td>{g.email}</td>
                        <td>{g.phoneNo}</td>
                        <td>{g.address}</td>
                        <td>{g.payerId}</td>
                        <td>{g.isActive?'Active':'Inactive'}</td>
                        <td><JisButton variant='plain' onClick={()=>onEdit(g,i)}>Edit</JisButton></td>
                    </tr>
                   )} )}
                </tbody>
            </table>
        </div>
        </div>}   
      {tab=='states' && <div  className='tab_view'>
            <div style={{textAlign:'right'}}> <JisButton variant='plain' onClick={onAdd}>Add State</JisButton></div>
            <div className='table'>
            <div class="section-cases">
                <span>States</span><span className='total'>{states?.length}</span>
            </div>
            <table className="case-table">
                <thead>
                    <tr>
                        <th>SN</th>
                        <th>Title</th>
                        <th>Status</th>
                        <th>Action</th>

                    </tr>
                </thead>
                <tbody>
                   { states.map((g, i) => { return (
                    <tr>
                        <td>{i+1}</td>
                        <td>{g.title}</td>
                         <td>{g.isActive?'Active':'Inactive'}</td>
                        <td><JisButton variant='plain' onClick={()=>onEdit(g,i)}>Edit</JisButton></td>
                    </tr>
                   )} )}
                </tbody>
            </table>
        </div>
        </div>}  
      {tab=='lgs' && <div  className='tab_view'>
            <div style={{textAlign:'right'}}> <JisButton variant='plain' onClick={onAdd}>Add Local Government</JisButton></div>
            <div className='table'>
            <div class="section-cases">
                <span>Local Governments</span><span className='total'>{lgs?.length}</span>
            </div>
            <table className="case-table">
                <thead>
                    <tr>
                        <th>SN</th>
                        <th>Title</th>
                        <th>State</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                   { lgs.map((g, i) => { return (
                    <tr>
                        <td>{i+1}</td>
                        <td>{g.title}</td>
                        <td>
                            {Constants.getItemById(states,g.stateId)?.title}
                        </td>
                        <td>{g.isActive?'Active':'Inactive'}</td>
                        <td><JisButton variant='plain' onClick={()=>onEdit(g,i)}>Edit</JisButton></td>
                    </tr>
                   )} )}
                </tbody>
            </table>
        </div>
        </div>}  
     {tab=='cities' && <div  className='tab_view'>
            <div style={{textAlign:'right'}}> <JisButton variant='plain' onClick={onAdd}>Add City</JisButton></div>
            <div className='table'>
            <div class="section-cases">
                <span>Cities</span><span className='total'>{cities?.length}</span>
            </div>
            <table className="case-table">
                <thead>
                    <tr>
                       <th>SN</th>
                        <th>Title</th>
                        <th>State</th>
                        <th>LG</th>
                        <th>Status</th>
                        <th>Action</th> 
                    </tr>
                </thead>
                <tbody>
                   { cities.map((g, i) => { return (
                    <tr>
                        <td>{i+1}</td>
                        <td>{g.title}</td>
                        <td>
                             {Constants.getItemById(states,g.stateId)?.title}
                        </td>
                        <td>
                             {Constants.getItemById(lgs,g.localGovtAreaId)?.title}
                        </td>
                         <td>{g.isActive?'Active':'Inactive'}</td>
                        <td><JisButton variant='plain' onClick={()=>onEdit(g,i)}>Edit</JisButton></td>
                    </tr>
                   )} )}
                </tbody>
            </table>
        </div>
        </div>}   
     </div>
     <BackLoader open={loading} />
   {tab=='divisions' && isDialog && <JisDialogForm title="Division" onClose={onClose}>
        <form onSubmit={onSave}>
              <div  className="input-group">
                <label> Title</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="user" />
                  <input placeholder='Title' name="title" value={division.title} maxLength={50}
                    onChange={onDivisionChange}
                    required={true}
                  />
                </div>
                </div>
                <div  className="input-group">
                <label> Code</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="user" />
                  <input placeholder='Code' name="code" value={division.code} maxLength={10}
                    onChange={onDivisionChange}
                    required={true}
                  />
                </div>
                </div>
                <div  className="input-group">
                <label> Email</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="user" />
                  <input placeholder='Email'  type="email" name="email" value={division.email}
                    onChange={onDivisionChange}
                    required={true}
                  />
                </div>
                </div>  
                <div  className="input-group">
                <label> Address</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="user" />
                  <input placeholder='Address' name="address" value={division.address} maxLength={100}
                    onChange={onDivisionChange}
                    required={true}
                  />
                </div>
                </div>  
                <div  className="input-group">
                <label> PayerID</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="user" />
                  <input placeholder='Payer Id' name="payerId" value={division.payerId} maxLength={15}
                    onChange={onDivisionChange}
                    required={true}
                  />
                </div>
                </div>   
                <div  className="input-group">
                <label> Phone</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="user" />
                  <input placeholder='Phone' name="phone" value={division.phone}
                    onChange={onDivisionChange}
                    required={true}
                  />
                </div>
                </div> 
 <JisCheckbox value={division.isActive} label="Active" onChange={(e)=>setDivision({...division,isActive:e})} />
        <div>
            <JisButton type="submit">{division.id==0?'Save':'Update'}</JisButton>
        </div>
        </form>
     </JisDialogForm>}  
    {tab=='states' && isDialog && <JisDialogForm title="State" onClose={onClose}>
        <form onSubmit={onSave}>
            <div  className="input-group">
                <label> Title</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="user" />
                  <input placeholder='Title' name="title" value={state.title}
                    onChange={onStateChange}
                    required={true}
                  />
                </div>
                </div>
            <JisCheckbox value={state.isActive} label="Active" onChange={(e)=>setState({...state,isActive:e})} />     
        <div>
            <JisButton type="submit">{state.id==0?'Save':'Update'}</JisButton>
        </div>
        </form>
     </JisDialogForm>}
     {tab=='lgs' && isDialog && <JisDialogForm title="Local Govt" onClose={onClose}>
        <form onSubmit={onSave}>
             <div  className="input-group">
                <label> Title</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="user" />
                  <input placeholder='Title' name="title" value={lg.title}
                    onChange={onStateChange}
                    required={true}
                  />
                </div>
                </div>
                <div className="select-group">
                <label> State <span className="required">*</span> </label>
                <select name="stateId" required value={lg.stateId}  onChange={onStateChange} >
                    <option value=''>Select State </option>
                    {states.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                        {opt.title}
                    </option>
                    ))}
                </select>
                </div>
               <JisCheckbox value={lg.isActive} label="Active" onChange={(e)=>setLg({...lg,isActive:e})} />       
        <div>
            <JisButton type="submit">{lg.id==0?'Save':'Update'}</JisButton>
        </div>
        </form>
     </JisDialogForm>}
     {tab=='cities' && isDialog && <JisDialogForm title="City" onClose={onClose}>
        <form onSubmit={onSave}>
 <div  className="input-group">
                <label> Title</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="user" />
                  <input placeholder='Title' name="title" value={city.title}
                    onChange={onCityChange}
                    required={true}
                  />
                </div>
                </div>
                <div className="select-group">
                <label> State <span className="required">*</span> </label>
                <select name="stateId" required value={city.stateId}  onChange={onCityChange} >
                    <option value=''>Select State</option>
                    {states.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                        {opt.title}
                    </option>
                    ))}
                </select>
                </div>
                <div className="select-group">
                <label> Local Government <span className="required">*</span> </label>
                <select name="localGovtAreaId" required value={city.localGovtAreaId}  onChange={onCityChange} >
                    <option value=''>Select LG</option>
                    {lgs.filter((e)=>e.stateId==city.stateId).map((opt) => (
                    <option key={opt.id} value={opt.id}>
                        {opt.title}
                    </option>
                    ))}
                </select>
                </div>
               <JisCheckbox value={city.isActive} label="Active" onChange={(e)=>setCity({...city,isActive:e})} />       
        <div>
            <JisButton type="submit">{city.id==0?'Save':'Update'}</JisButton>
        </div>
        </form>
     </JisDialogForm>}   
    </div>
  );
}

export default LocationSettings;